module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\"><path fill=\"#777\" fill-rule=\"evenodd\" d=\"M10.93 8.25c-.447 0-.893-.446-.893-.892 0-.447.446-.893.893-.893.446 0 .892.446.892.893 0 .446-.446.893-.892.893zm.78 6.363a.763.763 0 0 1-.78.781.763.763 0 0 1-.782-.78v-4.02c0-.446.335-.78.782-.78.446 0 .78.334.78.78v4.02zM10.93 2C6.018 2 2 6.018 2 10.93c0 4.91 4.018 8.93 8.93 8.93 4.91 0 8.93-4.02 8.93-8.93 0-4.912-4.02-8.93-8.93-8.93z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/svgo-loader?{"plugins":[{"removeTitle":true}]}!./resources/assets/img/check.svg
// module id = 7UNq
// module chunks = 1